import { getUserAuthValues } from "@/src/utils/auth"
import { getCookie } from "@/src/utils/browser"
import { isUserSignedIn } from "@/src/utils/generalUtils/checkUserLogin"
import { useEffect, useState } from "react"
import { useGetSearchParamsObj } from "../srp/searchParams"


// const HOME_AI_SEARCH_COOKIE = 'homeAISearch'
// const SRP_SMART_FILTER_SORT_COOKIE = 'srpSmartFilterSort'
const AIModeActiveCookie = 'AIModeActive'
export const useAIFeatureEnableManager = () => {
    const { isSeoQuery } = useGetSearchParamsObj()
    const [aiFeatureEnabled, setAiFeatureEnabled] = useState({
        homeAISearch: false,
        srpSmartFilterSort: false
    })

    useEffect(() => {

        if (isSeoQuery) return
        const accessUserEmail =
            [
                'jay.prakash@flyin.com',
                'pradip.mandal@flyin.com',
                'himanshu@flyin.com',
                'rameshwar.patil@flyin.com',
                'jairam.nagasaivc@flyin.com',
                'prasad.bandaruvc@flyin.com',
                'aryan.kaushik@flyin.com',
                'nischay.prasher@flyin.com',
                'sourabh@flyin.com',
                'vishwa@flyin.com',
                'nakul.goyal@flyin.com'
            ].map(email => email.toLowerCase())
        const isSignedIn = isUserSignedIn()
        const { email } = getUserAuthValues()
        const isActiveAIModeFromCookie = getCookie(AIModeActiveCookie)
        const isUserHasaAccess = isSignedIn && email && accessUserEmail.includes(email?.toLowerCase()?.trim())
        const isActiveAIMode = isUserHasaAccess || isActiveAIModeFromCookie == "true"
        setAiFeatureEnabled({
            homeAISearch: isActiveAIMode,
            srpSmartFilterSort: isActiveAIMode
        })
    }, [])

    return aiFeatureEnabled
}
